<template>
    <div class="recruitIndex">
        <div :style="{'background-image': 'url('+ RecruitBg +')'}" class="recruit-avatar flex flex-a-i-center">
            <img :src="pageData.avatar_url" class="avatar-img" />
            <div class="recruit-msg">
                <p class="msg-name">{{pageData.true_name || pageData.nickname || '-'}}</p>
                <p class="msg-charge" v-if="pageData.level_name"><span v-if="pageData.is_staff == 1">【教职员工】</span>{{pageData.level_name || '-'}}</p>
                <p class="msg-referee" v-if="pageData.parent">推荐人：{{pageData.tParent || pageData.parent || '-'}}</p>
            </div>
        </div>
        <div class="recruit-count flex flex-a-i-center">
            <router-link :to="{name:'Achievement', query: {id: pageData.level}}">
                <img src="@/assets/recruit/student_icon_achievement@3x.png" class="count-img"/>
                <p class="count-title">我的业绩</p>
                <p class="count-num">{{pageData.total_price || '0.00'}}</p>
            </router-link>
            <router-link to="/Fans">
                <img src="@/assets/recruit/student_icon_fans@3x.png" class="count-img"/>
                <p class="count-title">我的粉丝</p>
                <p class="count-num">{{pageData.fans_amount || '0'}}</p>
            </router-link>
        </div>
        <div class="recruitFunc">
            <!-- 推广海报库 -->
            <div class="per-line" @click="targetPage({path:'/Source'})">
                <div class="recruit-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/recruit/student_icon_spread@3x.png" class="recruitFunc-icon"/>
                        <span class="recruitFunc-text">推广海报库</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div>
            <!-- 推广文章库 -->
            <div class="per-line" @click="targetPage({path:'/Notice/NoticeCard?type=article'})">
                <div class="recruit-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/recruit/artice.png" class="recruitFunc-icon"/>
                        <span class="recruitFunc-text">推广文章库</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div>
            <!-- 我的团队 -->
            <div class="per-line" @click="targetPage({path:'/Team',query:{level: pageData.level}})">
                <div class="recruit-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/recruit/student_icon_team@3x.png" class="recruitFunc-icon"/>
                        <span class="recruitFunc-text">我的团队</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div>
            <!-- 我的学生 -->
            <div class="per-line" @click="targetPage({name:'Preview'})" v-if="pageData.is_staff == 1">
                <div class="recruit-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/recruit/edit.png" class="recruitFunc-icon"/>
                        <span class="recruitFunc-text">我的学生</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div>
            <!-- 合伙人招募 -->
            <div class="per-line" @click="targetPage({path:'/InvitationCode', query:{type: pageData.level}})" v-if="pageData.level > 2">
                <div class="recruit-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/recruit/student_icon_invite@3x.png" class="recruitFunc-icon"/>
                        <span class="recruitFunc-text">合伙人招募</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div>
            <!-- 提现 -->
            <div class="per-line" @click="targetPage({path:'/Cash'})">
                <div class="recruit-func flex flex-j-c-sb flex-a-i-center">
                    <div class="flex flex-a-i-center flex-j-c-center">
                        <img src="@/assets/recruit/student_icon_cash@3x.png" class="recruitFunc-icon"/>
                        <span class="recruitFunc-text">奖金提现</span>
                    </div>
                    <div class="flex flex-j-c-e method-right flex-a-i-center">
                        <img class="right-icon" src="@/assets/right.png">
                    </div>
                </div>
            </div>

            <!-- 问题答疑 -->
            <div class="per-line" @click="targetPage({path:'/Questions'})" v-if="pageData.is_staff == 1">
              <div class="recruit-func flex flex-j-c-sb flex-a-i-center">
                <div class="flex flex-a-i-center flex-j-c-center">
			            <img src="@/assets/recruit/student_icon_invite@3x.png" class="recruitFunc-icon"/>
			            <span class="recruitFunc-text">问题答疑</span>
                </div>
                <div class="flex flex-j-c-e method-right flex-a-i-center">
			            <img class="right-icon" src="@/assets/right.png">
                </div>
              </div>
          </div>
    </div>

        <div style="height:70px"></div>

        <Footer vals="tabRecruit" :vtext.sync="vtext"/>
    </div>
</template>

<script>
import Footer from '@/components/Footer.vue';
import {FuserMsg} from '@/api';
import { Toast, MessageBox } from 'mint-ui';

export default {
    name: 'RecruitIndex',
    components: {
      Footer
    },
    data() {
      return {
        RecruitBg: require('@/assets/recruit/student_bg@3x.png'), // 背景图
        pageData: { avatar_url: require('@/assets/avatar.png'), }, // 页面数据
        sessionData: {}, // 缓存数据
        vtext: '0元上大学' // 底部bar文字
      }
    },
    watch:{
    },
    created() {
      this.sessionData = JSON.parse(sessionStorage.getItem('_sessionData'));
      if (this.sessionData && this.sessionData.RecruitIndex) this.pageData = JSON.parse(this.sessionData.RecruitIndex);
      this.getUserMsg();
    },
    methods: {
      // 获取页面数据
      getUserMsg() {
        FuserMsg().then(res => {
          if (res.code !== 0) { Toast({message: res.msg, className: 'iconfont icon-close', duration: 2000}); }
          if (!this._tools.checkSData(res.data, 'RecruitIndex')) {
            this.pageData = res.data;
          }
          this.vtext = res.data.level == 1 ? '推荐有礼' : res.data.level == 2 ? '合伙人计划' : '0元上大学'
          if (res.data.level === -1) {
            MessageBox.alert('请先进行报名操作...').then(action => {
                this.$router.replace({name: 'HomePage'});
            });
          }
        })
      },
      // 合伙人（弃用）
      toInvitationCode() {
        if (this.pageData.level > 2) {
          this.$router.push({name:'InvitationCode', query:{type: this.pageData.level}})
        } else {
          Toast({message: '招生满三人，才有资格邀请助理招生人！请继续努力…', className: 'iconfont icon-close', duration: 2000});
        }
      },
      // 页面跳转
      targetPage(e) {
        this.$router.push(e);
      }
    }
}

</script>
<style lang='less' scoped>
.recruitIndex{
    min-height: 100vh;
    .recruit-avatar{
        width: 100%;
        height: 1.4rem;
        background-size: 100% 100%;
        background-repeat: no-repeat;
        position: relative;
        padding: 0 0.16rem;
        .avatar-img{
            width: 0.56rem;
            height: 0.56rem;
            border-radius: 50%;
            border: 2px solid white;
        }
        .recruit-msg{
            color: white;
            font-size: 0.17rem;
            margin-left: 0.23rem;
            text-align: left;
            line-height: 0.22rem;
            .msg-name{
                font-weight: bold;
            }
            .msg-charge, .msg-referee{
                font-size: 0.13rem;
            }
        }
    }
    .recruit-count{
        padding: 0.18rem 0;
        background: white;
        &>a{
            width: 50%;
        }
        P{
            margin-top: 0.02rem;
        }
        .count-img{
            width: 0.31rem;
            height: 0.31rem;
        }
        .count-title{
            font-size: 0.14rem;
            color: #333333;

        }
        .count-num{
            font-size: 0.15rem;
            color: #E01212;
            font-weight: bold;
        }
    }
    .recruitFunc{
        margin-top: 0.1rem;
        padding: 0 0.16rem;
        background: white;
        &>div:last-child{
            border: none;
        }
        .recruit-func{
            .recruitFunc-icon{
                width: 0.21rem;
                height: 0.21rem;
                margin-right: 0.08rem;
            }
            .recruitFunc-text{
                font-size: 0.16rem;
                color: #000000;
            }
        }
    }
}
</style>
